import { IJobApplication } from "@/shared/api/employment"
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"
import SearchSvg from '@/shared/assets/images/MagnifyingGlass.svg'
import { useUpdateJobApplicationModal } from "@/features/update-job-application"

interface InspectApplicationProps {
    application: IJobApplication
}

export const InspectApplication: FC<InspectApplicationProps> = ({ application }) => {
    const { openInspectJobApplicationModal } = useUpdateJobApplicationModal()
    return (
        <DropdownItem 
            onClick={() => openInspectJobApplicationModal(application)}
            icon={SearchSvg} 
            label={"Просмотреть"}        
        />
    )
}